<div class="mainContainer">
	<div class="districtSearchPanel" (mouseout)="onBlur()">

		<form [formGroup]="districtForm">
			<span class="formSearchDistrict">
				<div class="topBar">
					<mat-form-field class="txtDistrictFilterMatCss">
						<mat-label>Filter</mat-label>
						<input id="txtFilter" type="text" matInput type="text" formControlName="txtFilter"
							name="txtFilter" placeholder="{{filterPlaceholder}}" class="txtDistrictFilterCss"
							(keyup)="applyFilter($event)">
					</mat-form-field>

					<span class="districtFilterBtnPanel">
						<button class="btnSearch" mat-raised-button color="primary" [matTooltip]="tooltipSearch"
							(click)="fnProcessFilter(true)">
							<i class="material-icons">search</i></button>&nbsp;
						<button class="btnClear" mat-raised-button aria-label="Clear" [matTooltip]="tooltipClearFilter"
							(click)="fnReset($event)">
							<i class="material-icons">delete_forever</i>
						</button>&nbsp;&nbsp;
					</span>
				</div>
			</span>
		</form>

		<span class="decreaseHeight">
						<mat-spinner class="loading-shade" diameter="20" *ngIf="isLoadingResults"></mat-spinner>
			
		</span>
		<div class=".myPaginatorContainer">
			<div class="myPaginator">
				<mat-paginator #districtPaginator [length]="this.myData.length" [pageIndex]="0" [pageSize]="5"
					[pageSizeOptions]="pagingService.paging.pageSizeOption" showFirstLastButtons>
				</mat-paginator>
			</div>
		</div>
		<div>
			<mat-table class="mat-elevation-z8" [dataSource]="dataSource">
				<ng-container matColumnDef="select" sticky>
					<mat-header-cell *matHeaderCellDef>
						<mat-checkbox [color]="'primary'" (change)="$event ? masterToggle() : null"
							[checked]="selection.hasValue() && isAllSelected()"
							[indeterminate]="selection.hasValue() && !isAllSelected()">
						</mat-checkbox>
					</mat-header-cell>
					<mat-cell *matCellDef="let row">
						<!-- (click)="$event.stopPropagation() $event ?"  : null-->
						<mat-checkbox [color]="'primary'" 
							(change)="fnSelectRow(row)" [checked]="selection.isSelected(row)">
						</mat-checkbox>&nbsp;
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="ID">
					<mat-header-cell *matHeaderCellDef [style.display]="'none'">ID</mat-header-cell>
					<mat-cell *matCellDef="let row" [style.display]="'none'"> {{row.ID}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="DISTRICTS">
					<mat-header-cell *matHeaderCellDef>DISTRICTS</mat-header-cell>
					<mat-cell *matCellDef="let row"> {{row.DISTRICTS}} </mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>
		</div>


	</div>
</div>